import React, { Children } from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function AchievementsSection() {
  const achievements = [{
    text: 'Resolver la decoración de la fiesta en minutos, con plantillas listas para imprimir.',
    emoji: '🖨️'
  }, {
    text: 'Lograr un cumpleaños inolvidable con diseños únicos y profesionales.',
    emoji: '🎂'
  }, {
    text: 'Sorprender a tu hijo y a todos los invitados con una celebración digna de Pinterest.',
    emoji: '📌'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -30
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 20
      }
    }
  };
  return <Section className="bg-white" data-id="element-15">
      <div className="max-w-3xl mx-auto text-center" data-id="element-16">
        <motion.h2 initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-2xl md:text-4xl font-black text-purple-700 uppercase tracking-tight mb-8" data-id="element-17">
          🎉 3 cosas que lograrás con este kit:
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-5" data-id="element-18">
          {achievements.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-3 text-left bg-purple-50 rounded-xl px-5 py-4 border border-purple-100" data-id="element-19">
              <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-20" />
              <p className="text-gray-700 font-medium text-base md:text-lg" data-id="element-21">
                {item.text} <span className="text-xl" data-id="element-22">{item.emoji}</span>
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </Section>;
}